import styled from 'styled-components';
import {Box} from '@sproutsocial/seeds-react-box';
import {Skeleton} from '@sproutsocial/seeds-react-skeleton';
import {Text} from '@sproutsocial/seeds-react-text';
import {type TypePageData} from '../services';

type TypeDescriptionProps = {
	page: TypePageData | null | undefined;
};

const DescriptionText = styled(Text)`
	white-space: pre-wrap;
	overflow-wrap: break-word;
`;

export default function Description({page}: TypeDescriptionProps) {
	if (!page) {
		return (
			<Box px={450} pb={350} display='flex' justifyContent='center'>
				<Skeleton width='600px' height='72px' />
			</Box>
		);
	}

	const {hero_text} = page;

	if (!hero_text) return null;

	return (
		<Box px={450} pb={350} display='flex' justifyContent='center'>
			<DescriptionText forwardedAs='p' fontSize={300} textAlign='center' width='100%' maxWidth='600px'>
				{hero_text}
			</DescriptionText>
		</Box>
	);
}
